import { getRoundingMethod } from "./_lib/getRoundingMethod.js";
import { differenceInMilliseconds } from "./differenceInMilliseconds.js";

/**
 *
 */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function differenceInSeconds(laterDate, earlierDate, options) {
  const diff = differenceInMilliseconds(laterDate, earlierDate) / 1000;
  return getRoundingMethod(options?.roundingMethod)(diff);
}

/*                                */
export default differenceInSeconds;
